module.exports = __webpack_public_path__ + "media/images/emblems/Kappel-blason-b52c0544eb581b44401b46440c4cb6a4.png";